export default "__VITE_ASSET__5a5546cb__"